// extracted by mini-css-extract-plugin
export default {"hvnly-settings-api__card":"r9c6OGSTsMGdHsTMizek","hvnly-settings-api__card-header":"zPpp2aiq6Ww9hcXwDoaQ","hvnly-settings-api__card-body":"bs0XAF3B6r1TaDXJT9UY"};